export default __webpack_public_path__ + "static/media/HYUNDAI.233a9354.png";